var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"primary"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',_vm._l((_vm.aimlDevices),function(item,index){return _c('v-col',{key:index,attrs:{"lg":"6","md":"12","sm":"12","xs":"12"}},[_c(item,{tag:"component"})],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }